<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="그룹메뉴 관리" device="web" :IsUseSearchRequirement="true">
        <template v-slot:SearchRequirement>
          <v-radio-group v-model="selectedSvcGubn" row>
            <v-radio
              color="radio"
              v-for="(item, index) in svcGubnDataSource"
              :key="index"
              :label="item.minorNm"
              v-model="item.minorCd"
            ></v-radio>
          </v-radio-group>
        </template>

        <!-- headerTitle="권한그룹" -->
        <template v-slot:body>
          <div class="d-flex align-center mb-3">
            <div class="d-flex justify-end align-center">
              <v-text-field
                class="i-search-panel-text-field editor_bg"
                placeholder="통합 검색"
                dense
                solo
                hide-details="auto"
                clearable
                @change="changeInput"
              />

              <v-select
                :menu-props="{ offsetY: true }"
                class="i-search-panel-text-field ml-2 editor_bg"
                placeholder="권한그룹"
                dense
                solo
                :items="selectList"
                item-text="grpAuthNm"
                item-value="grpAuthCd"
                v-model="selectedGrpAuth"
                clearable
                @change="btnSearch()"
              />
            </div>
            <div class="d-flex justify-end align-center">
              <v-radio-group v-model="selectedAuth" row>
                <v-radio
                  color="radio"
                  v-for="(item, index) in authDataSource"
                  :key="index"
                  :label="item.minorNm"
                  v-model="item.minorCd"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
          <DxTreeList
            id="menuOfgroupManageTreeList"
            class="layout-col-height00"
            width="100%"
            :ref="dxTreeListRef"
            :data-source="menus"
            :auto-expand-all="true"
            :hover-state-enabled="true"
            :show-row-lines="true"
            :show-borders="true"
            :column-auto-width="true"
            :allow-column-resizing="true"
            :root-value="0"
            :focused-row-enabled="true"
            data-structure="plain"
            key-expr="id"
            parent-id-expr="parentId"
            @selection-changed="onSelectionChanged"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <!-- 선택모드  -->
            <DxSelection mode="multiple" :recursive="true" />
            <!-- mode : "multiple" | "none" -->
            <!-- 수정 -->
            <DxEditing :allow-updating="true" mode="batch" :select-text-on-edit-start="true" />
            <DxColumn data-field="id" :visible="false" />
            <DxColumn
              data-field="menuNm"
              caption="메뉴명"
              width="250"
              :allow-search="true"
              :allow-sorting="false"
              :allow-editing="false"
            />
            <DxColumn
              data-field="grpAuthNm"
              caption="권한그룹명"
              width="120"
              alignment="center"
              :allow-search="false"
              :allow-editing="false"
              :allow-sorting="true"
            />
            <DxColumn
              data-field="progNm"
              caption="프로그램명"
              width="300"
              :allow-editing="false"
              :allow-sorting="false"
            />
            <DxColumn
              data-field="svcGubn"
              data-type="string"
              caption="웹/모바일"
              width="75"
              alignment="center"
              :allow-sorting="false"
              :allow-editing="false"
            >
              <DxLookup
                :data-source="svcGubnDataSource"
                display-expr="minorNm"
                value-expr="minorCd"
              />
            </DxColumn>
            <DxColumn
              data-field="auth"
              data-type="boolean"
              caption="권한"
              width="70"
              :allow-sorting="false"
              header-cell-template="title-header"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="sort"
              caption="순서"
              width="75"
              :allow-sorting="false"
              header-cell-template="title-header"
              :visible="false"
            />
            <DxColumn
              data-field="schAh"
              data-type="boolean"
              caption="조회"
              width="70"
              :allow-sorting="false"
              header-cell-template="title-header"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="savAh"
              data-type="boolean"
              caption="저장"
              width="70"
              :allow-sorting="false"
              header-cell-template="title-header"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="delAh"
              data-type="boolean"
              caption="삭제"
              width="70"
              :allow-sorting="false"
              header-cell-template="title-header"
              edit-cell-template="checkBoxEditor"
            />

            <DxColumn
              data-field="exlAh"
              data-type="boolean"
              caption="출력"
              width="70"
              :allow-sorting="false"
              header-cell-template="title-header"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="fn1Ah"
              data-type="boolean"
              caption="업로드"
              width="70"
              :allow-sorting="false"
              header-cell-template="title-header"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="fn2Ah"
              data-type="boolean"
              caption="다운로드"
              width="70"
              :allow-sorting="false"
              header-cell-template="title-header"
              edit-cell-template="checkBoxEditor"
            />
            <!-- 20220630 LYJ 현재 즐겨찾기 기능이 없으므로 노출시켜 렌더링 이슈에서 벗어나도록 우선은 막음 -->
            <!-- <DxColumn
                      data-field="favoriteYn"
                      data-type="boolean"
                      caption="즐겨찾기"
                      width="80"
                      :allow-sorting="false"
                      header-cell-template="title-header"
                      edit-cell-template="checkBoxEditor"
            />-->

            <!-- checkbox -->
            <template #checkBoxEditor="{ data: cellInfo  }">
              <DxCheckBox
                :value="cellInfo.value == 'Y' ? true : false"
                :on-value-changed="value => onCheckValueChanged(value, cellInfo)"
              />
            </template>

            <template #title-header="{ data }">
              <div>
                <!-- <p style="font-size:16px"></p> -->
                {{ data.column.caption }}
                <DxCheckBox
                  width="22"
                  :on-value-changed="value => onCheckHeaderValueChanged(value.value, data.column.name)"
                />
              </div>
            </template>
          </DxTreeList>
        </template>
      </i-card-vertical>
      <i-card-right
        headerTitle
        :useBtnList="buttonUseList"
        @btnSearch="btnSearch()"
        @btnSave="btnSave()"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iPageTitle from '@/components/common/iPageTitle.vue'

import DxCheckBox from 'devextreme-vue/check-box'
import { DxColumn, DxEditing, DxLookup, DxRowDragging, DxSelection, DxTreeList } from 'devextreme-vue/tree-list'

import { getCommonCode, getGrpAuth } from '@/api/common/commonApi'
import { getMenuOfgroupManage, saveMenuOfgroupManage } from '@/api/setting/menuOfgroupManage'

import Baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가

export default {
  extends: Baseview, //20220414 LYJ base page 추가
  name: 'menuOfgroupManage',
  components: {
    'i-page-title': iPageTitle,
    'i-card-top': iCardTop,
    iCardVertical,
    DxLookup,
    DxTreeList,
    DxSelection,
    DxColumn,
    DxRowDragging,
    DxEditing,
    DxCheckBox
  },
  data() {
    return {
      drawerLayout: false,
      dxTreeListRef: 'menuOfgroupManageTreeList',
      menus: [],
      selectList: [],
      selectedGrpAuth: '',
      buttonUseList: [
        'btnSearch', //조회
        // 'btnAdd',     //추가
        'btnSave' //저장
        // 'btnDelete'   //삭제
      ],
      // 웹/모바일 dataSource
      svcGubnDataSource: [],

      authDataSource: [
        { minorCd: '', minorNm: '전체' },
        { minorCd: 'Y', minorNm: '권한있음' },
        { minorCd: 'N', minorNm: '권한없음' }
      ],
      // vuetify의 radio value는 ""을 넣어도 0으로 값이 맞춰짐
      selectedAuth: 0,
      selectedSvcGubn: 'W'
    }
  },
  computed: {
    treeList: function() {
      return this.$refs[this.dxTreeListRef].instance
    }
  },
  beforeMount() {
    Promise.all([
      getGrpAuth(), // 권한 그룹 들고오기
      getCommonCode('CM004') // majorCd : "CM004" 프로그램 Type
    ]).then(res => {
      // 권한 그룹 들고오기
      this.selectList = []
      this.selectList = res[0].list
      this.selectedGrpAuth = res[0].list[0].grpAuthCd
      //this.selectList.unshift({ grpAuthCd: '', grpAuthNm: '전체' })

      // majorCd : "CM004" 프로그램 Type
      this.svcGubnDataSource = []
      this.svcGubnDataSource = res[1].list
      // 켜질때 조회
      this.btnSearch()
    })
  },
  mounted() {},
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    changeInput(value) {
      this.treeList.searchByText(value)
    },
    btnSearch() {
      this.treeInit()
      this.openLoading('searching')
      let params = {
        grpAuthCd: this.selectedGrpAuth,
        auth: this.selectedAuth.toString().replace(0, ''), // vuetify의 라디오 value는 "" 을 넣으면 0으로 나와서 "" 으로 바꿔줌
        svcGubn: this.selectedSvcGubn.toString().replace(0, ''),
        platformType: 'P'
      }
      getMenuOfgroupManage(params, true)
        .then(res => {
          this.menus = []
          this.menus = res.list

          // DxtreeList 버그로 인하여 전체확장을 껏다가 킴
          this.treeList.option('autoExpandAll', false)
          this.treeList.option('autoExpandAll', true)
          // 포커스 첫번째로
          this.treeList.option('focusedRowIndex', -1)
          this.treeList.option('focusedRowIndex', 0)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      let selectedRows = this.treeList.getSelectedRowsData()
      if (selectedRows.length === 0) {
        // this.$vToastify.warning({ body: this.$t('selectionData') })
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.treeList.saveEditData()

          // let selectedRows = this.treeList.getSelectedRowsData()
          let selectedprogramRows = selectedRows
          this.openLoading()

          saveMenuOfgroupManage(selectedprogramRows, true)
            .then(res => {
              let params = {
                grpAuthCd: this.selectedGrpAuth,
                svcGubn: this.selectedSvcGubn.toString().replace(0, ''),
                auth: this.selectedAuth.toString().replace(0, ''), // vuetify의 라디오 value는 "" 을 넣으면 0으로 나와서 "" 으로 바꿔줌
                platformType: 'P'
              }
              getMenuOfgroupManage(params)
                .then(res => {
                  this.treeInit()
                  this.menus = []
                  this.menus = res.list

                  // DxtreeList 버그로 인하여 전체확장을 껏다가 킴
                  this.treeList.option('autoExpandAll', false)
                  this.treeList.option('autoExpandAll', true)

                  // 포커스 첫번째로
                  this.treeList.option('focusedRowIndex', -1)
                  this.treeList.option('focusedRowIndex', 0)
                })
                .catch(error => {
                  if (error.response && error.response.data) {
                    if (error.response.data.code == -2001) {
                      this.vToastify(this.$t(error.response.data.msg), 'warn')
                    }
                  }
                })
                .finally(res => {
                  this.endLoading()
                })
            })
            .finally(res => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    ///////////////////////////////////////
    /*            TreeList Event         */
    ///////////////////////////////////////
    onSelectionChanged(e) {
      // 최근에 선택된 열의 node 정보
      let sourceNode
      if (e.currentSelectedRowKeys.length !== 0) {
        sourceNode = this.treeList.getNodeByKey(e.currentSelectedRowKeys)
      } else {
        sourceNode = this.treeList.getNodeByKey(e.currentDeselectedRowKeys)
      }

      // 열 삭제시에도 해당 메소드를 타기때문에 return
      if (sourceNode == null) return
    },
    // 체크박스 값 변경될 시 타는 이벤트
    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')

      // 재귀적으로 트리아래 모든 데이터 변경을 위한 함수
      this.recursiveDataChange(cellInfo)

      this.treeList.selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },
    // 헤더의 값 변경될 시 타는 이벤트
    onCheckHeaderValueChanged(value, headerField) {
      this.menus.forEach(element => {
        element[headerField] = value ? 'Y' : 'N'
      })
      this.treeList.selectAll()
    },
    onEditingStart(e) {
      if (e.column.dataField == 'menuNm' || e.column.dataField == 'grpAuthNm' || e.column.dataField == 'svcGubn') e.cancel = true
    },
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged

        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      // this.treeList.selectRows(cellInfo.row.key, true)
    },

    treeInit() {
      this.treeList.clearSelection()
      this.treeList.cancelEditData()
    },
    ///////////////////////////////////////
    /*   0          etc Event             */
    ///////////////////////////////////////
    // 재귀적으로 트리아래 모든 데이터 변경을 위한 함수
    recursiveDataChange(cellInfo) {
      // 자식 객첵 변경하기
      this.upperTreeDataChange(cellInfo)
      // 부모 객체 변경하기
      this.downTreeDataChange(cellInfo)
      console.log(this.menus)
    },
    upperTreeDataChange(cellInfo) {
      if (cellInfo.value === 'Y' && cellInfo.column.dataField !== 'auth') {
        //console.log('#@@@@@@@@@@@@@@@@@@@@@@@')
        // 현재 변경한 Column의 rowindex 조회
        let rowIndex = this.treeList.getRowIndexByKey(cellInfo.data.id)
        // 권한 이외의 항목에 Y가 들어간 경우 권한도 Y 입력 해주기
        this.treeList.cellValue(rowIndex, 'auth', 'Y')
      } else if (cellInfo.value === 'N') {
        //console.log('########', cellInfo.column.dataField)
        let rowIndex = this.treeList.getRowIndexByKey(cellInfo.data.id)

        //권한(Auth) N 처리 할 필요가 없음
        //this.treeList.cellInfo(rowIndex, '')
        //this.treeList.cellValue(rowIndex, 'auth', 'N')
      }
      // 현재 Row Select 처리
      this.treeList.selectRows(cellInfo.data.id, true)

      // this.treeList.getNodeByKey 가 제대로 동작하지 않아 임시적으로 전체적으로 돌림
      this.menus.forEach(element => {
        // 상속(현재 Cell을 paranet로 가지고 있는 객체) 항목 탐색
        if (element.parentId === cellInfo.data.id) {
          // 순서가 바뀌어서 변하였으니 저장하기 위해 선택 check
          this.treeList.selectRows(element.id, true)
          // batch
          let rowIndex = this.treeList.getRowIndexByKey(element.id)
          this.treeList.cellValue(rowIndex, cellInfo.column.dataField, cellInfo.value)
          // cell mode 였을때
          //element[`${cellInfo.column.dataField}`] = cellInfo.value

          // 재귀적으로 함수를 타기위해 cellInfo 만들어줌

          let tempCellInfo = {
            data: {
              id: element.id
            },
            column: {
              dataField: cellInfo.column.dataField
            },
            value: cellInfo.value
          }

          this.upperTreeDataChange(tempCellInfo)
        }
      })
    },
    downTreeDataChange(cellInfo) {
      //부모 객체 정보 가져오기
      let parent = this.menus.find(element => element.id === cellInfo.data.parentId)

      //현제 객체가 최상위면 return으로 SKIP
      if (parent == null) {
        this.treeList.selectRows(cellInfo.data.id, true)
        return
      }

      console.log('########', cellInfo.column.dataField)

      let rowIndex = this.treeList.getRowIndexByKey(parent.id)
      // 자식 객체가 N 처리 되는 경우
      // 모든 자식 객체가 N 처리 되는 경우 부모 객체도 N 처리 하도록 재귀
      if (cellInfo.value === 'N') {
        let nFlag = true
        this.menus.forEach(element => {
          // 부모가 같은 객체 탐색
          if (element.parentId === cellInfo.data.parentId && element.id !== cellInfo.data.id) {
            let childRowIndex = this.treeList.getRowIndexByKey(element.id)
            console.log(
              'values : ' + this.treeList.cellValue(childRowIndex, 'menuNm') + '-',
              this.treeList.cellValue(childRowIndex, cellInfo.column.dataField)
            )
            // 'Y' 인 객체가 하나라도 있다면 부모객체는 변경하지 않음
            if (this.treeList.cellValue(childRowIndex, cellInfo.column.dataField) == 'Y') nFlag = false
          }
        })

        if (nFlag) {
          console.log('downTree N : flag')
          this.treeList.cellValue(rowIndex, cellInfo.column.dataField, cellInfo.value)
        }
      }
      // 자식 객체가 Y 처리 되는 경우
      // 자식 객체만 Y 여서는 안되기에 부모 객체도 Y 처리 하도록 재귀
      else if (cellInfo.value === 'Y') {
        this.treeList.cellValue(rowIndex, cellInfo.column.dataField, cellInfo.value)
        // 무엇이 Y처리 되든 권한은 Y 처리가 되어야 한다.
        this.treeList.cellValue(rowIndex, 'auth', 'Y')
      }

      //재귀 처리
      let tempCellInfo = {
        data: {
          id: parent.id,
          parentId: parent.parentId
        },
        column: {
          dataField: cellInfo.column.dataField
        },
        value: cellInfo.value
      }

      this.downTreeDataChange(tempCellInfo)
      /*
      this.menus.forEach(element => {
        // 상속(현재 Cell을 paranet로 가지고 있는 객체) 항목 탐색
        if (element.id === parent.id) {
          // 순서가 바뀌어서 변하였으니 저장하기 위해 선택 check
          // batch
          let rowIndex = this.treeList.getRowIndexByKey(element.id)
          this.treeList.cellValue(rowIndex, cellInfo.column.dataField, cellInfo.value)
        }
      })

      /*
      switch (cellInfo.value === 'Y') {
        case cellInfo.column.dataField === 'auth':
          parent.auth = 'Y'
          break
        case cellInfo.column.dataField === 'schAh':
          parent.schAh = 'Y'
          break
        case cellInfo.column.dataField === 'savAh':
          parent.savAh = 'Y'
          break
        case cellInfo.column.dataField === 'delAh':
          parent.delAh = 'Y'
          break
        case cellInfo.column.dataField === 'exlAh':
          parent.exlAh = 'Y'
          break
        case cellInfo.column.dataField === 'fn1Ah':
          parent.fn1Ah = 'Y'
          break
        case cellInfo.column.dataField === 'fn2Ah':
          parent.fn2Ah = 'Y'
          break
      }
      */
      // 권한이외의 항목이 체크가 되어 있다면 권한도 Y로 체크가 되어야함 ??? 잘못된 표현
      // 어떤 항목이라도 Y가 된다면 권한은 Y로 체크가 되어야 한다.
      // 권한 이외의 항목에 Y가 들어간 경우 권한도 Y 입력 해주기 -- 하위객첵 처리에서 기처리됨
      /*
      if (cellInfo.value === 'Y' && cellInfo.column.dataField !== 'auth') {
        let rowIndex = this.treeList.getRowIndexByKey(cellInfo.data.id)
        this.treeList.cellValue(rowIndex, 'auth', 'Y')

        this.treeList.selectRows(cellInfo.data.id, true)
      }
      */

      /*
      // batch
      let rowIndex = this.treeList.getRowIndexByKey(cellInfo.data.id)
      this.treeList.cellValue(rowIndex, cellInfo.column.dataField, cellInfo.value)
      // cell mode 였을때
      // parent[`${cellInfo.column.dataField}`] = cellInfo.value

      let tempCellInfo = {
        data: {
          id: parent.id,
          parentId: parent.parentId
        },
        column: {
          dataField: cellInfo.column.dataField
        },
        value: cellInfo.value
      }
      this.downTreeDataChange(tempCellInfo)
      */
    }
  }
}
</script>
<style lang="scss" scoped>
// .search-select {
//   max-width: 230px;
// }
// .search-text-field {
//   max-width: 220px;
// }
</style>
